<template>
  <div class="sub-menu-wrap">
    <p class="menu-subtitle" v-if="menu.subtitle">
      {{ menu.subtitle }}
    </p>
    <ul class="sub-menu-list">
      <li v-for="(item, index) in menu.list" :key="index" class="sub-menu-list__item">
        <!--если пункт меню сразу ссылается на роут и не имеет дочернего меню-->
        <router-link v-if="item.link"
                     :to="item.link"
                     :title="item.title"
                     class="sub-menu-list__link"
        >
          <p class="sub-menu-list__text">{{ item.title }}</p>
        </router-link>
        <!--для пунктов с дочерними меню-->
        <div v-if="item.sub_menu"
             :title="item.title"
             class="sub-menu-list__link"
             @click.capture="switchMenu(item.sub_menu)"
        >
          <p class="sub-menu-list__text">{{ item.title }}</p>
          <div>
            <svg class="arrow-next-icon" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 11L6 6L1 1" stroke="currentColor"/>
            </svg>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AppMenuListSections',
  computed: {
    menu () {
      return this.$store.getters.activeMenu
    }
  },
  methods: {
    switchMenu (subMenu) {
      this.$store.dispatch('switchMenu', { menu: subMenu, isSubmenu: true })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.menu-subtitle {
  padding: 20px 15px 20px 20px;
  font-weight: bold;
  animation: fadeIn .3s ease-in;
}

.sub-menu-list {
  padding-bottom: 20px;
  animation: fadeIn .3s ease-in;

  &__link {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 10px 15px 10px 20px;
    color: $font_color_six;
    transition: .3s;
    cursor: pointer;

    &:hover {
      background-color: $color__orange;
      color: $color__white;
    }

    &.router-link-active {
      background-color: $color__orange;
      color: $color__white;
    }
  }

  &__text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  &:last-child {
    padding-bottom: 0;
  }
}
</style>
